import "react-app-polyfill/ie11"; // We seem to need the Promise polyfill, because Babel / Webpack do not correctly transform it in the modules
import React from "react";
import ReactDOM from "react-dom";
import i18n from "./lib/i18n";
import configureStore from "./lib/store";
import configureHistory from "./lib/history";
import configureTheme from "./lib/theme";
import urlQueryToStore from "./lib/urlQueryToActions";
import { loadPortalData } from "./lib/portalData";
import {
  clientConfig as getClientConfig,
  clientConfigIds,
  checkClientConfig,
  domElement,
  getCustomTheme,
  getInitialPortalData,
  readClientConfig,
  themeVariableName,
  updateClientConfig,
  updateI18n
} from "./lib/clientConfig";
import { offerType as getOfferType } from "./lib/offerType";
import { CSS_CLASS_PREFIX } from "./constants/css";
import { switchClientConfig } from "./actions/clientConfig";
import { switchOfferType } from "./actions/offerType";
import { switchPortal } from "./actions/portal";
import Root from "./components/Root";
import { resetFilters } from "./actions/filter";
import { resetSorts } from "./actions/sort";
import { WIDGETS } from "./constants/widgets";
import { resetCollapsibles } from "./actions/componentStatus/collapsibles";
import { resetModal } from "./actions/modal";
import { resetOfferResultsPagination } from "./actions/componentStatus/offerResultsPagination";
import { resetHasChangedFilters } from "./actions/componentStatus/hasChangedFilters";

function initializeWidget(clientConfigId, count) {
  if (checkClientConfig(readClientConfig(clientConfigId))) {
    let clientConfig = getClientConfig(clientConfigId);
    getInitialPortalData(clientConfig).then((initialPortalData) => {
      getCustomTheme(clientConfig, initialPortalData.clientData).then(() => {
        clientConfig = updateClientConfig(clientConfig, initialPortalData);
        const themeTdsId = `${CSS_CLASS_PREFIX}p${count}`;
        const theme = configureTheme(
          themeVariableName(clientConfig),
          themeTdsId
        );
        const storeId = "tdsPcStore-" + clientConfig.id;
        const widget = clientConfig.widget;
        let history;
        let historySearch;
        if (clientConfig.options.updateUrl) {
          history = configureHistory();
          historySearch = history.location.search;
        }

        const offerType = getOfferType(clientConfig, historySearch);

        if (offerType !== undefined) {
          const store = configureStore(storeId, history);

          /**
           * Make the store available in the browser, this is not necessary for the
           * application, but now we can use the console to talk to the store, like
           *  - window[storeId].dispatch({type: 'SWITCH_PORTAL', id: 'ukTelecom'})
           *  - window[storeId].getState()
           *
           *  The idea is that the complete app can be controlled by dispatching actions on
           *  the store, rendering should never be necessary to control the state.
           */
          window[storeId] = store;

          // Dispatch initial actions so everything is set
          store.dispatch(switchClientConfig(clientConfig));
          store.dispatch(switchPortal(clientConfig.portal));
          if (WIDGETS[widget].portalData) {
            loadPortalData(
              store.dispatch,
              clientConfig,
              store.getState().portalData
            );
          }
          store.dispatch(switchOfferType(offerType));
          store.dispatch(resetCollapsibles());
          store.dispatch(resetFilters(clientConfig));
          store.dispatch(resetHasChangedFilters());
          store.dispatch(resetModal());
          store.dispatch(resetOfferResultsPagination());
          store.dispatch(resetSorts(clientConfig));

          // Set language
          i18n.changeLanguage(clientConfig.options.language);

          // Add clientConfig i18n resources
          updateI18n(i18n, clientConfig);

          // Configure store from the query
          if (clientConfig.options.updateUrl) {
            urlQueryToStore(store, clientConfig.id, historySearch);
          }

          domElement(clientConfig).then((elementId) => {
            ReactDOM.render(
              <Root
                elementId={elementId}
                store={store}
                theme={theme}
                themeTdsId={themeTdsId}
              />,
              document.getElementById(elementId)
            );
          });
        }
      });
    });
  }
}

window.tdsPcFrontendScriptLoaded = window.tdsPcFrontendScriptLoaded || false;

if (window.tdsPcFrontendScriptLoaded !== true) {
  window.tdsPcFrontendScriptLoaded = true;

  clientConfigIds().then((clientConfigIds) => {
    let i;
    for (const clientConfigId of clientConfigIds) {
      i = +1;
      initializeWidget(clientConfigId, i);
    }
  });
}
